import { Linking, Platform } from 'react-native';

export const getAppStoreUrl = (
    appStoreLocale: string,
    appName: string,
    appStoreId: string
): string => `https://apps.apple.com/${appStoreLocale}/app/${appName}/id${appStoreId}`;

export const getPlayStoreUrl = (playStoreId: string): string =>
    `https://play.google.com/store/apps/details?id=${playStoreId}`;

type OpenInStoreProps = {
    appName: string;
    appStoreId: string;
    playStoreId: string;
    appStoreLocale: string;
    deeplinkToWeb?: `https://${string}`;
};

export const openInStore = async ({
    appStoreLocale = 'us',
    appName,
    appStoreId,
    playStoreId,
    deeplinkToWeb
}: OpenInStoreProps): Promise<void | undefined> => {
    if (deeplinkToWeb) {
        Linking.openURL(deeplinkToWeb);
        return;
    }
    if (Platform.OS === 'ios') {
        const appStoreURL = getAppStoreUrl(appStoreLocale, appName, appStoreId);
        Linking.openURL(appStoreURL);
    } else {
        Linking.openURL(getPlayStoreUrl(playStoreId));
    }
};
